export default "__VITE_ASSET__CyPSI99y__"